import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { X } from "lucide-react";
import { API } from "@/App";

export default function AdminLogin({ onClose, onSuccess }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/admin/login`, { code });
      onSuccess(data.token);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Code incorrect");
      setShake(true);
      setTimeout(() => setShake(false), 450);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[70] flex items-center justify-center bg-burgundy-deep/70 p-4 backdrop-blur-sm"
      onClick={onClose}
      data-testid="admin-login-modal"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.92, y: 24 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        onClick={(e) => e.stopPropagation()}
        className={`w-full max-w-sm rounded-3xl bg-white p-8 shadow-2xl ${shake ? "animate-shake" : ""}`}
      >
        <div className="flex items-start justify-between">
          <img src="/logo.jpg" alt="Logo La Table de Saint-François" className="h-14 w-14 rounded-full shadow ring-1 ring-burgundy/10" />
          <button onClick={onClose} aria-label="Fermer" className="rounded-full p-1.5 text-stone-400 transition-colors hover:bg-stone-100 hover:text-stone-700" data-testid="admin-login-close">
            <X className="h-5 w-5" />
          </button>
        </div>

        <h3 className="mt-5 font-serif text-2xl font-semibold text-stone-900">Espace Employés</h3>
        <p className="mt-1 text-sm text-stone-500">Réservé à l'équipe. Entrez le code d'accès.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <input
            type="password"
            inputMode="numeric"
            autoFocus
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Code d'accès"
            className="w-full rounded-xl border border-stone-200 bg-cream/60 px-4 py-3.5 text-center font-mono text-lg tracking-[0.5em] outline-none transition-all placeholder:tracking-normal focus:border-burgundy focus:ring-2 focus:ring-burgundy/15"
            data-testid="admin-passcode-input"
          />
          {error && (
            <p className="text-center text-sm font-medium text-red-700" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading || !code}
            className="w-full rounded-full bg-burgundy py-3.5 text-sm font-semibold text-cream transition-all hover:bg-burgundy-dark disabled:opacity-60"
            data-testid="admin-login-button"
          >
            {loading ? "Vérification…" : "Accéder à l'espace"}
          </button>
        </form>
      </motion.div>
    </motion.div>
  );
}
